<template>
  <div class="summary">
    <div style="margin-bottom: 20px;">
      <h1 >Use The Text Area <span style="color:red;">Or</span> the URL Input To Summarize</h1>
      <h2>Note: It could take a couple of min to generate... </h2>
    </div>
    <div class="row">
      <div class="summary__article-container">
        <label for="article" class="summary__label"></label>
        <textarea v-model="myText" placeholder="Add the text to summarize" class="summary__article"
                  name="article" id="article" cols="0" rows="10"></textarea>
      </div>
    </div>
    <div class="row">
      <div class="summary__article-container">
        <label for="url" class="summary__label"></label>
        <input v-model="myUrl" placeholder="Add the url to summarize" class="summary__article"
               name="url" id="url">
      </div>
    </div>
    <div id="summary__title-container" class="row">
      <div class="col-1-of-1">
        <input @click="getSummary()" type="button" class="btn summary__button" value="Get Highlights">
        <div>
          <template v-if="isLoadingVisible">
            <img src="../assets/loading.gif" alt="">
          </template>
        </div>
      </div>
    </div>
    <div class="row">
      <div>
        <h1 v-if="getMySummary.length>0" class="summary__title">Highlights</h1>
        <div class="summary__nlpcontainer" style="margin-bottom: 100px;">
          <ul class="summary__nlplist">
            <li v-for="(s,i) in getMySummary" :key="i" class="summary__nlpitem">
              <code v-html="s"></code>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
export default {
  components: {},
  computed: {
    getMySummary() {
      let that = this;
      let data = !this.$store.getters.articleSummary ? [] : this.$store.getters.articleSummary;
      if (data.length > 0) {
        that.isLoadingVisible = false;
      }
      return data;
    }
  },
  data() {
    return {
      isLoadingVisible: false,
      myText: '',
      myUrl: ''
    }
  },
  beforeDestroy() {
    this.$store.dispatch('articleSummary', {body: []});
  },
  created() {
  },
  methods: {
    getSummary() {
      this.isLoadingVisible = true;
      this.$store.dispatch('articleSummary', {
            body: this.myText,
            url: this.myUrl,
            article_id: 0
          }
      );
    }
  }
}
</script>
<!--{-->
<!--"data":"",-->
<!--"maxsn" :12,-->
<!--"url":"https://proandroiddev.com/building-a-family-tree-dsl-with-jetpack-compose-syntax-fe652ce6cb0f?_branch_match_id=898516540418217402&gi=4d0975473ea7"-->
<!--}-->
<style lang="scss" scoped>
</style>
